module.exports = __webpack_public_path__ + "img/prize-sm-dark.04df3371.png";